import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPreviewOffStyle0 = cosmosIconCss;

const CosmosIconPreviewOff$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPreviewOff extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd15603c04bdcf66336e2cfc17312ace9ed59935b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3c978c969207ddea4a8d4c0bade85a0bad001892', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2d62d4a163b317e04f3c3adb9f631468394afc1b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.227 3.146a.527.527 0 0 1 .728 0l3.414 3.36a9.54 9.54 0 0 1 2.622-.358c3.554 0 6.471 1.813 8.806 5.19.27.43.27.974 0 1.404l-.013.019c-.705 1.048-1.482 1.947-2.326 2.688l2.355 2.318c.2.202.2.524 0 .727l-.364.359a.537.537 0 0 1-.74 0L3.852 4.233a.506.506 0 0 1 0-.718l.375-.369ZM16.35 14.36c.734-.63 1.415-1.406 2.043-2.319-2.028-2.871-4.462-4.356-7.403-4.356-.451 0-.89.035-1.317.105l1.459 1.435c1.468.07 2.646 1.23 2.718 2.675l2.5 2.46ZM5.031 8.24c-1.02.804-1.955 1.833-2.808 3.073a1.298 1.298 0 0 0-.007 1.445c2.252 3.346 5.205 5.173 8.775 5.173a9.53 9.53 0 0 0 3.305-.574l-1.243-1.223a8.08 8.08 0 0 1-2.062.26c-2.957 0-5.418-1.495-7.383-4.352.78-1.113 1.624-2.018 2.535-2.708L5.03 8.239Zm3.179 3.128c-.054.215-.082.44-.082.672 0 1.556 1.282 2.818 2.863 2.818.236 0 .465-.028.684-.08l-3.465-3.41Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPreviewOffStyle0; }
}, [1, "cosmos-icon-preview-off", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-preview-off"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-preview-off":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPreviewOff$1);
            }
            break;
    } });
}

const CosmosIconPreviewOff = CosmosIconPreviewOff$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPreviewOff, defineCustomElement };
